export const SAVE_SALON_TAG_REQUEST = 'SAVE_SALON_TAG_REQUEST';
export const SAVE_SALON_TAG_SUCCESS = 'SAVE_SALON_TAG_SUCCESS';
export const SAVE_SALON_TAG_FAILURE = 'SAVE_SALON_TAG_FAILURE';
